/**
* @copyright
* Copyright(c) 2018 SICK AG
*/

const style = `
:host {
  box-sizing: border-box;
  display: flex;
  font-size: 1rem;
}

.navigation {
  height: 3.1428571429rem;
  width: 100%;
  background-color: #FFFFFF;
  background-color: var(--davinci-color-background, #FFFFFF);
}
.navigation.minimal .items {
  flex-direction: row-reverse;
}

.items {
  align-items: center;
  display: flex;
  flex-direction: row;
  height: 2.9285714286rem;
  width: 100%;
}

.bottom-line {
  height: 0.2142857143rem;
  width: 100%;
  background-color: #C5CACC;
  background-color: var(--davinci-color-outline-light, #C5CACC);
}

:host(:not([type=workflow])) .items {
  height: 100%;
}
:host(:not([type=workflow])) .bottom-line {
  display: none;
}
`;
export { style };
